import type { TVariableProps } from "@/dialogs/share-dialog/types";
import { useGetFastVarsQuery } from "@api/fast-versioning";
import { useMemo } from "react";
import { toDefinitionMap } from "./repeatable-definitions-context";

/**
 * The org's variable definitions from the fast-vars query (RTK cache, shared
 * with the picker), for hosts that don't already have them — the editor's
 * rows pop-up. Kept apart from the context module so cells can be rendered
 * without a store.
 */
export const useFastVarDefinitions = (): Map<string, TVariableProps> => {
  const { data } = useGetFastVarsQuery(undefined);
  return useMemo(() => {
    const rows = (data ?? []) as Array<{
      _id?: string;
      archived?: boolean;
      variable?: Record<string, unknown>;
    }>;
    return toDefinitionMap(
      rows
        .filter((row) => !row.archived && row.variable)
        .map(
          (row) =>
            ({ ...row.variable, _id: row._id }) as unknown as TVariableProps,
        ),
    );
  }, [data]);
};
